import React, { forwardRef } from 'react';
import styles from './textarea.module.css';

// Extend the props to include all input attributes
// interface TextAreaProps
//   extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const TextArea = forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={`${styles.textarea} ${className}`}
      {...props} // Spread all props, allowing standard input attributes
      ref={ref}
    />
  );
});
